export default __webpack_public_path__ + "static/events-light-b949267a155694b244762c505d692a36.png";